import { Component, OnInit, Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
declare var $: any;

@Component({
    selector: 'app-home',
    templateUrl: './home.component.html',
    styleUrls: ['./home.component.css']
})
@Injectable()
export class HomeComponent implements OnInit {

    public production: boolean = environment.production;

    constructor() {
    }

    ngOnInit() {
    }

    onImpersonateButtonClick() {
        $('#impersonateModal').modal();
    }

    onAchDialogButtonClick() {
        $('#achDialogModal').modal();
    }

}
